import { combineReducers, configureStore } from "@reduxjs/toolkit";
import { moatNameSlices } from "../slices/moatNameSlice";
import { privateKeySlices } from "../slices/privateKeySlice";
import storage from 'redux-persist/lib/storage';
import { persistReducer } from 'redux-persist';
import thunk from 'redux-thunk';
import { secretSlices } from "../slices/secretSlice";
import { loadedMoat } from "../slices/loadedMoat";
import { fundingPools } from "../slices/fundingPools";
import { toggleControl } from "../slices/toggleControlSlices";
import { newTable } from "../slices/newTableSlice";
import { newRow } from "../slices/newRowSlice";
import { newRowIndex } from "../slices/newRowIndexSlice";
import { cellEdit } from "../slices/cellEditSlice";
import { cellEditIndex } from "../slices/cellEditIndex";
import { cellEditColumn } from "../slices/cellEditColumn";

const persistConfig = {
    key: 'root',
    storage,
  }

const appReducer = combineReducers({
    moatName: moatNameSlices,
    privateKey: privateKeySlices,
    secret: secretSlices,
    loadedMoat: loadedMoat,
    fundingPools: fundingPools,
    toggleControl: toggleControl,
    newTable: newTable,
    newRow: newRow,
    newRowIndex: newRowIndex,
    cellEdit: cellEdit,
    cellEditIndex: cellEditIndex,
    cellEditColumn: cellEditColumn
})


const persistedReducer = persistReducer(persistConfig, appReducer)



const store = configureStore({
    reducer: persistedReducer,
    devTools: process.env.NODE_ENV !== 'production',
    middleware: [thunk]
})

export default store;